import {useState} from "react";
import {useDoctorAppointments, useDoctors} from "../../hooks";
import {buildColDefs} from "../../components/dataTables/buildColDefs";
import {LeftSideMenu} from "../../components/leftSideMenu/LeftSideMenu";
import DataTable from "../../components/dataTables/DataTable";
import {Doctor} from "../../data-parsing/doctors/Doctor";
import {AddDoctorFormTemplate} from "../../data-parsing/doctors/FormTemplate";
import {CreationForm, CreationFormTemplate} from "../../components/form/CreationForm";
import DragDropInput from "../../components/form/DragDropInput";
import {TabbedContent} from "../../components/tabs/TabbedContent";
import {UserAppointmentDoctor} from "../../data-parsing/userAppointment/UserAppointment";

export function Nutritionists() {
    const [query, setQuery] = useState(null);
    let {doctors, notValidated, createDoctor, deleteDoctor, updateDoctor, deleteValidate} = useDoctors(query);
    let colDefs = buildColDefs(Doctor);

    return <LeftSideMenu active="nutritionists">
        <div id="wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <h4 className="header-title m-t-0 m-b-30 pull-right">NUTRICIONISTAS</h4>
                            <TabbedContent removeContent={true} tabHeaders={[
                                <button data-toggle="tab" aria-expanded="true"><i
                                    className="fas fa-plus-circle"></i> NUEVO NUTRICIONISTA</button>,
                                <button data-toggle="tab" aria-expanded="false"
                                        onClick={() => setQuery(0)}><i
                                    className="far fa-eye"></i> LISTAR NUTRICIONISTAS</button>,
                                <button data-toggle="tab" aria-expanded="false"
                                        onClick={() => setQuery(0)}><i
                                    className="fa fa-check-square-o"></i> VALIDAR NUTRICIONISTAS</button>,
                            ]}>
                                <div id="tabAddDoctors" className="in active">
                                    <div className="row">
                                        <CreationForm createFunction={createDoctor}>
                                            <div className="col-xs-12 col-md-5">
                                                <div id="recipesImages">
                                                    <div className="form-group">
                                                        <label>Foto</label>
                                                        <DragDropInput fileTypes={["JPG", "PNG", "GIF"]}
                                                                       style={{width: "100%", height: "300px"}}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <CreationFormTemplate formTemplate={AddDoctorFormTemplate}
                                                                  dataTemplate={Doctor}/>

                                            <div className="col-sm-12">
                                                <button
                                                    className="btn btn-rounded btn-purple m-t-20 ml-10"><i
                                                    className="far fa-save"></i> Guardar
                                                    Nutricionista
                                                </button>

                                            </div>
                                        </CreationForm>
                                    </div>
                                </div>
                                <div id="tabViewDoctors" >
                                    <DataTable colDefs={colDefs} data={doctors} dataId={"Doctors"} resizable={true}
                                               allowHiddenColumns={true} scrollX={false}
                                               editElement={updateDoctor} deleteElement={deleteDoctor}
                                               className="table table-bordered panel-group"/>
                                </div>
                                <div id="tabViewValidates">
                                    <DataTable colDefs={colDefs} data={notValidated} dataId={"Validates"} resizable={true}
                                               allowHiddenColumns={true} scrollX={false}
                                               /*editElement={updateDoctor}*/ deleteElement={deleteValidate}
                                               className="table table-bordered panel-group"/>
                                </div>
                            </TabbedContent>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </LeftSideMenu>
}